export default __webpack_public_path__ + "static/media/folder-big.6eff1051.svg";